import { Button, Theme, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';
const {
  DARK_TEXT,
  ERROR_BUTTON_BORDER,
  LIGHT_TEXT,
  PASS_BUTTON_BORDER,
  PLAIN_TEXT,
  PRIMARY_BUTTON_BORDER,
  LIGHT_CONTAINER,
  DARK_CONTAINER_FIELDS_FLOATING,
} = COLORS;

export const ProjectItemCont = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER,
  borderRadius: 10,
  height: 'fit-content',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const ProjectRoleCont = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
  padding: 15,
}));

export const ProjectHeader = styled('div')<Theme, { responsive?: number }>(({ theme, responsive }) => ({
  padding: 15,
  paddingBottom: 0,
  display: 'flex',
  justifyContent: 'start',

  '& .MuiTypography-root': {
    fontSize: 12,
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: responsive ? 'column' : 'row',
  },
}));

export const ButtonCont = styled('div')<Theme, { isRow?: number }>(({ theme, isRow }) => ({
  marginLeft: 'auto',
  paddingLeft: 15,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: isRow ? 'row' : 'column',
    gap: 10,
  },
}));

export const DescriptionText = styled(CustomTypography)<Theme>(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '13px !important',
  [theme.breakpoints.down('sm')]: {
    whiteSpace: 'pre-wrap',
  },
}));

export const ButtonsCont = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  marginLeft: 20,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'row',
    marginLeft: 0,
  },
}));

export const ActionButton = styled(Button)<Theme, { negative?: number; green?: number }>(
  ({ theme, negative, green }) => ({
    padding: '2px 10px',
    fontSize: 10,
    backgroundColor: 'transparent',
    borderColor: green ? PASS_BUTTON_BORDER : negative ? ERROR_BUTTON_BORDER : PRIMARY_BUTTON_BORDER,
    [theme.breakpoints.down('md')]: {
      padding: 0,
      height: 30,
      minWidth: 30,
    },
    minWidth: 95,
  }),
);

export const MainInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginRight: 10,
  minWidth: 230,
  maxWidth: 230,
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    minWidth: 100,
    maxWidth: 'unset',
  },
}));

export const DatesLocationInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  paddingLeft: 20,
  marginRight: 10,
  minWidth: 130,
}));

export const RateInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginRight: 40,
}));

export const UnionsText = styled(CustomTypography)(({ theme }) => ({
  color: LIGHT_TEXT,
  fontSize: 14,
}));

export const ProjectText = styled(CustomTypography)(({ theme }) => ({
  fontSize: '20px !important',
  fontWeight: 'bolder',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const CompanyText = styled(CustomTypography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  gap: 2,
}));

export const LabelsCont = styled('div')<Theme, { rate?: number }>(({ theme, rate }) => ({
  marginRight: 10,
  maxWidth: 100,
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: 10,
  gap: 4,
  fontSize: 13,
  [theme.breakpoints.down('md')]: {
    paddingLeft: 0,
  },
}));

export const Labels = styled('p')(({ theme }) => ({
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  whiteSpace: 'nowrap',
}));

export const HiddenRoles = styled(Button)(({ theme }) => ({
  height: 30,
  width: 290,
  marginLeft: 15,
  backgroundColor: 'transparent',
  border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
}));
